import React, { Component } from 'react'
import { connect } from 'react-redux'
import {single, multiple} from '../../utils/Eenheden'
import { withRouter } from 'react-router-dom'
import { addToCart } from '../../redux/actions/cartActions'
import { showUtilModal, showMessageModal } from '../../redux/actions/miscActions'

export class PakkettenShop extends Component {

  handleAddToCart = (product) => {
    const { user, isAuthenticated } = this.props.user;
    const btn = (
      <div>
        winkelwagen <i className="fas fa-angle-right"></i>
      </div>
    );
    if (isAuthenticated) {
      this.props.addToCart(
        product.id,
        1,
        user.uid,
        product.pakketNaam,
        btn,
        this.props.history
      );
    } 
    // else if (isAuthenticated) {
    //   const feedback = {
    //     type: "warning",
    //     txt: "voltooi uw profiel om door te gaan",
    //   };
    //   this.props.showMessageModal(feedback);
    //   this.props.history.push("/user");
    // } 
    else if (!isAuthenticated) {
      this.props.showUtilModal("login");
    }
  };

  render() {
    const {pakketten } = this.props
    const { pakketFilters, searchValue } = this.props.shop;
    const pakkettenList = pakketten.filter(x => x.pakketNaam.toLowerCase().includes(searchValue.toLowerCase())).filter(x => x.typePakket.includes(pakketFilters.toString().split(",").join(" ").toLowerCase())).map(x => { return(
      <div className="pakket-overview" key={x.id}>
        <div className="product-image">
          <img src={x.productImage} alt=""/>
        </div>
        <div className="name">
    <p>{x.pakketNaam}</p>
        </div>
      
        <div className="pakket-producten">
          <ul>
            {x.producten.map(y => { return (
              <li key={y.productNaam + y.productEenheid} >{y.aantalNum} x {y.aantalNum > 1 ? multiple[y.productEenheid] : single[y.productEenheid]} {y.productNaam}</li>
            )})}
          </ul>
        </div>
        <div className="pakket-buttons" onClick={() => this.handleAddToCart(x)}>

        <button onClick={() => this.handleAddToCart(x)}>
                {new Intl.NumberFormat("IN", {
                  style: "currency",
                  currency: "SRD",
                }).format(`${x.itemPrice}`)}
              </button>
                </div>
      </div>
    )})
    return (
      <div className="pakketten-shop-overview">
        {pakkettenList}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  products: state.products,
  shop: state.shop,
  user: state.user,
  profile: state.profile,
  misc: state.misc
});

export default connect(mapStateToProps, { addToCart, showUtilModal, showMessageModal })(withRouter(PakkettenShop))
